<template>
  <div id="digital-flop">

    <template >
      <div
        class="digital-flop-item"
        v-for="item in total"
        :key="item.title"
        :style="{width:item.width}"
      >
        <div class="digital-flop-title">{{ item.title }}</div>
        <div class="digital-flop" style="text-align: center;display: flex;align-items: center">
          <span :style="item.number.style" style="transform: scale(0.55) translate(65%,18%)">{{ item.unit }}</span>

          <FlopBox :config="item.number" :list="item.unit?list:[1]"></FlopBox>
        </div>
      </div>
    </template>

    <dv-decoration-10/>
  </div>
</template>

<script>
import FlopBox from "@/components/FlopBox";

export default {
  name: 'DigitalFlop',
  props: {
    total: {
      type: Array,
      default() {
        return []
      }
    },
    list: {
      type: Array,
      default() {
        return [213]
      }
    }
  },
  components: {
    FlopBox
  },
  data() {
    return {
      digitalFlopData: []
    }
  },
  methods: {
    randomExtend(minNum, maxNum) {
      if (arguments.length === 1) {
        return parseInt(Math.random() * minNum + 1, 10)
      } else {
        return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10)
      }
    }
  },
  mounted() {
  }
}
</script>

<style lang="less">
#digital-flop {
  position: relative;
  height: 15%;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(6, 30, 93, 0.5);

  .dv-decoration-10 {
    position: absolute;
    width: 95%;
    left: 2.5%;
    height: 5px;
    bottom: 0px;
  }

  .digital-flop-item {
    width: 16.66%;
    height: 80%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 3px solid rgb(6, 30, 93);
    border-center: 3px solid rgb(6, 30, 93);
  }

  .digital-flop-title {
    font-size: 45px;
    margin-bottom: 20px;
  }

  .digital-flop {
    display: flex;
    font-size: 75px;
  }

  .unit {
    margin-left: 10px;
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    padding-bottom: 13px;
  }
}

@media screen and (max-width: 2000px) {
  #digital-flop {
    height: 12%;

    .dv-decoration-10 {
      height: 3px;
    }

    .digital-flop-item {
      border-left: 2px solid rgb(6, 30, 93);
      border-center: 2px solid rgb(6, 30, 93);
    }

    .digital-flop-title {
      font-size: 30px !important;
      margin-bottom: 15px;
    }

    .digital-flop {

      font-size: 30px;
    }

    .unit {
      margin-left: 5px;

      padding-bottom: 6px;
    }
  }

  @media screen and (max-width: 1600px) {
    #digital-flop {
      height: 12%;

      .dv-decoration-10 {
        height: 2px;
      }

      .digital-flop-item {
        border-left: 2px solid rgb(6, 30, 93);
        border-center: 2px solid rgb(6, 30, 93);
      }

      .digital-flop-title {
        font-size: 17px;
        margin-bottom: 12px;
      }

      .digital-flop {

        font-size: 30px;
      }

      .unit {
        margin-left: 4px;

        padding-bottom: 5px;
      }
    }
  }
}
</style>
